import {
  ApproveReviewInventorySnapshotHeaderRequest,
  DeleteInventorySnapshotHeaderRequest,
  GetInventorySnapshotHeaderRequest,
  GetInventorySnapshotHeadersRequest,
  GetInventorySnapshotLogRequest,
  InventorySnapshotHeader,
  InventorySnapshotLog,
  MergeInventorySnapshotHeadersRequest,
  ServiceResult,
  UpdateInventorySnapshotHeaderRequest,
} from '../models';
import ApiService from './api-service';

class InventorySnapshotHeaderService extends ApiService {
  private static classInstance: InventorySnapshotHeaderService;

  private constructor() {
    super('InventorySnapshotHeader');
  }
  public getInventorySnapshotHeader(
    request: GetInventorySnapshotHeaderRequest
  ): ServiceResult<InventorySnapshotHeader> {
    return this.get(`${this.baseUrl}/GetInventorySnapshotHeader`, request);
  }

  public getInventorySnapshotHeadersInReview(
    request: GetInventorySnapshotHeadersRequest
  ): ServiceResult<InventorySnapshotHeader[]> {
    return this.get(`${this.baseUrl}/GetInventorySnapshotHeadersInReview`, request);
  }

  public getInventorySnapshotHeadersCompleted(
    request: GetInventorySnapshotHeadersRequest
  ): ServiceResult<InventorySnapshotHeader[]> {
    return this.get(`${this.baseUrl}/GetInventorySnapshotHeadersCompleted`, request);
  }

  public approveInventorySnapshotHeader(
    request: ApproveReviewInventorySnapshotHeaderRequest
  ): ServiceResult<InventorySnapshotHeader> {
    return this.post(`${this.baseUrl}/ApproveInventorySnapshotHeader`, request);
  }

  public reviewInventorySnapshotHeader(
    request: ApproveReviewInventorySnapshotHeaderRequest
  ): ServiceResult<InventorySnapshotHeader> {
    return this.post(`${this.baseUrl}/ReviewInventorySnapshotHeader`, request);
  }
  public updateInventorySnapshotHeader(
    request: UpdateInventorySnapshotHeaderRequest
  ): ServiceResult<InventorySnapshotHeader> {
    return this.post(`${this.baseUrl}/UpdateInventorySnapshotHeader`, request);
  }

  public deleteInventorySnapshotHeader(request: DeleteInventorySnapshotHeaderRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteInventorySnapshotHeader`, request);
  }

  public mergeInventorySnapshotHeaders(
    request: MergeInventorySnapshotHeadersRequest
  ): ServiceResult<InventorySnapshotHeader> {
    return this.post(`${this.baseUrl}/MergeInventorySnapshotHeaders`, request);
  }

  public getInventorySnapshotLogs(request: GetInventorySnapshotLogRequest): ServiceResult<InventorySnapshotLog[]> {
    return this.get(`${this.baseUrl}/GetInventorySnapshotLogs`, request);
  }

  public static getInstance(): InventorySnapshotHeaderService {
    if (!this.classInstance) {
      this.classInstance = new InventorySnapshotHeaderService();
    }
    return this.classInstance;
  }
}

export default InventorySnapshotHeaderService;
